/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Personal data delete modal windows actions.
 *
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.17.0
 */

import { createAction } from '../app/createAction';
import { PERSONAL_DATA_DELETE_START, PERSONAL_DATA_DELETE_SUCCESS } from './personalDataDeleteConstants';
import {
    IPersonalDataDeleteStartAction,
    IPersonalDataDeleteSuccessAction,
    IPersonalDataDeleteSuccessPayload,
} from './personalDataDeleteTypes';

export const personalDataDeleteStartAction = ():
    IPersonalDataDeleteStartAction => createAction(PERSONAL_DATA_DELETE_START);

export const personalDataDeleteSuccessAction = (payload: IPersonalDataDeleteSuccessPayload):
    IPersonalDataDeleteSuccessAction => createAction(PERSONAL_DATA_DELETE_SUCCESS, payload);
